import React, { memo, Fragment } from 'react';
import './styles.css.js';

var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const regexEscape = /* @__PURE__ */ __name((str) => str.replace(/[\s#$()*+,.?[\\\]^{|}-]/g, "\\$&"), "regexEscape");
const HighlightedMatch = memo(
  ({
    wrap: Wrap = Fragment,
    children,
    searchTerm,
    renderHighlight = /* @__PURE__ */ __name((match, i) => /* @__PURE__ */ React.createElement("mark", {
      className: "mds-highlighted-match",
      key: i
    }, match), "renderHighlight")
  }) => {
    if (!searchTerm) {
      return /* @__PURE__ */ React.createElement(Wrap, null, children);
    }
    const reg = new RegExp(`(${regexEscape(searchTerm)})`, "i");
    return /* @__PURE__ */ React.createElement(Wrap, null, children.split(reg).map(
      (item, i) => i % 2 ? renderHighlight(item, i) : item
    ));
  }
);

export { HighlightedMatch };
//# sourceMappingURL=index.js.map
